export const debug = (message) => (d) => {
    // eslint-disable-next-line no-console
    console.debug(`${message}`, d);
};
//# sourceMappingURL=debug.js.map